import {JsonPipe} from '@angular/common';
import {Component} from '@angular/core';
import {CargoPaymentModel} from '../../../models/products.model';
import {AlertService} from '../../../services/notify/alert.service';
import {ProductionService} from '../../../services/production.service';

@Component({
    selector: 'app-cargo-transaction-list',
    standalone: true,
    imports: [
        JsonPipe
    ],
    templateUrl: './cargo-transaction-list.component.html',
    styleUrl: './cargo-transaction-list.component.scss'
})
export class CargoTransactionListComponent {

    allTransactions: CargoPaymentModel[] = [];

    constructor(
        private productionService: ProductionService,
        private alertService: AlertService,
    ) {
        this.getAllTransaction();
    }

    getAllTransaction(): void {
        this.productionService.getAllActiveTransaction().subscribe({
            next: res => {
                console.log(res);
                this.allTransactions = res.transactions;
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    createTransaction(): void {
        this.productionService.createTransaction().subscribe({
            next: res => {
                this.getAllTransaction();
                console.log(res);
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }
}
